import { marked } from 'marked'

marked.use({ breaks: true })

export function renderMarkdown(text) {
  return marked(text)
}
